<template>
    <div class="abandoned-supplier-page">
        <div class="abandoned-supplier-card">
            <h2 class="abandoned-supplier-title">
                《关于下线停止使用的旧供货编码的公告》
            </h2>
            <div class="abandoned-supplier-content">
                <p>尊敬的供应商：</p>
                <p class="indent">
                    您好！
                </p>
                <p class="indent">
                    根据我司业务调整及系统升级的需要，现决定自2026年6月30日起已下线此供货规则相关服务且不再支持登录。对于此供货规则已租赁的物资，下线日起将由我司进行停止物资租赁计费并执行报损处理，后续不再支持物资归还。因此，如有待归还物资请于下线日前尽快操作归还。下线后系统将隐藏相关数据，如需查阅此供货规则下的相关数据，可随时联系我司客服或业务对接人员，我们将竭诚为您服务。对于已对账未录入发票，或已对账未支付的结算单据，请尽快在下线前录入发票或联系财务处理。具体下线时间以系统实际执行时间为准。
                </p>
                <p class="indent">
                    感谢贵司对我司工作的理解与支持，如有任何疑问，欢迎随时与我们联系。
                </p>
                <p class="indent">
                    特此公告。
                </p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AbandonedSupplierPage',
};
</script>

<style lang="scss" scoped>
.abandoned-supplier-page {
    display: flex;
    justify-content: center;
    align-items: flex-start;
}
.abandoned-supplier-card {
    width: 100%;
    min-height: calc(100vh - 120px);
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.06);
    padding: 40px 50px;
    box-sizing: border-box;
    overflow: auto;
}
.abandoned-supplier-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    text-align: center;
    margin: 0 0 30px;
}
.abandoned-supplier-content {
    font-size: 14px;
    color: #333;
    line-height: 30px;
    p {
        margin: 0;
    }
    .indent {
        text-indent: 2em;
    }
}
</style>
